class ProductViewService {

    constructor() {
        this.product = {};
        this.variant = {};
        this.price = {};
    }

    setProduct(product) {
        this.product = product;
    }

    setVariant(variant) {
        this.variant = variant;
    }

    setPrice(price) {
        this.price = price;
    }

}

export default ProductViewService;
